import FormField from "../../register/components/FormField";

const WILLING_TO_TRAVEL_OPTIONS = [
  { value: "", label: "Select" },
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

function Step2VenueDetails({
  formData,
  errors,
  handleChange,
  cityOptions,
  VENUE_TYPE_OPTIONS,
  VENDOR_TYPE_OPTIONS,
  isVenueFlow,
  readOnly = false,
}) {
  
  if (!isVenueFlow) {
    return (
      <div className="step2-form step1-form step2-vendor">
        <div className="step1-form-row">
        <FormField
            label="Vendor type"
            name="vendor_type"
            type="select"
            value={formData.vendor_type}
            onChange={handleChange}
            error={errors.vendor_type}
            placeholder="Select vendor type"
            required
            options={VENDOR_TYPE_OPTIONS || []}
            disabled={readOnly}
            icon={
              <path
                d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
              />
            }
          />
          <FormField
            label="Willing to travel"
            name="willing_to_travel"
            type="select"
            value={formData.willing_to_travel}
            onChange={handleChange}
            error={errors.willing_to_travel}
            placeholder="Select"
            required
            options={WILLING_TO_TRAVEL_OPTIONS}
            disabled={readOnly}
            icon={
              <path
                d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
              />
            }
          />
   
        </div>

        <div className="step1-form-row">
          <FormField
            label="Years of experience"
            name="years_of_experience"
            type="number"
            min="0"
            value={formData.years_of_experience}
            onChange={handleChange}
            error={errors.years_of_experience}
            placeholder="0"
            required
            disabled={readOnly}
            icon={
              <path
                d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
              />
            }
          />
          <FormField
            label="Service radius (KM)"
            name="service_radius_km"
            type="number"
            min="0"
            value={formData.service_radius_km}
            onChange={handleChange}
            error={errors.service_radius_km}
            placeholder="0"
            required
            disabled={readOnly}
            icon={
              <path
                d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
              />
            }
          />
        </div>

   

        <FormField
          label="Full address (optional)"
          name="full_address"
          type="textarea"
          value={formData.full_address}
          onChange={handleChange}
          error={errors.full_address}
          placeholder="Enter full address if you have a physical office"
          rows={2}
          disabled={readOnly}
          icon={
            <path
              d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
            />
          }
        />

        <div className="step1-form-row">
          <FormField
            label="City"
            name="city"
            type="select"
            value={formData.city}
            onChange={handleChange}
            error={errors.city}
            placeholder="Select city"
            required
            options={cityOptions}
            disabled={readOnly}
            icon={
              <path
                d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
              />
            }
          />
          <FormField
            label="State"
            name="state"
            value={formData.state}
            onChange={handleChange}
            error={errors.state}
            placeholder="Enter state"
            required
            disabled={readOnly}
            icon={
              <path
                d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
              />
            }
          />
        </div>

        <FormField
          label="Pincode (if physical office)"
          name="pincode"
          value={formData.pincode}
          onChange={handleChange}
          error={errors.pincode}
          placeholder="6-digit pincode"
          disabled={readOnly}
          icon={
            <path
              d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
            />
          }
        />
      </div>
    );
  }

  return (
    <div className="step2-form step1-form">
      <div className="step1-form-row">
        <FormField
          label="Venue type"
          name="venue_type"
          type="select"
          value={formData.venue_type}
          onChange={handleChange}
          error={errors.venue_type}
          placeholder="Select Venue Type"
          required
          options={VENUE_TYPE_OPTIONS}
          disabled={readOnly}
          icon={
            <path
              d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
            />
          }
        />
        <FormField
          label="Number of halls"
          name="number_of_halls"
          type="number"
          min="0"
          value={formData.number_of_halls}
          onChange={handleChange}
          error={errors.number_of_halls}
          placeholder="0"
          required
          disabled={readOnly}
          icon={
            <path
              d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
            />
          }
        />
      </div>
      <div className="step1-form-row">
        <FormField
          label="Minimum capacity"
          name="capacity_min"
          type="number"
          min="0"
          value={formData.capacity_min}
          onChange={handleChange}
          error={errors.capacity_min}
          placeholder="0"
          required
          disabled={readOnly}
          icon={
            <path
              d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
            />
          }
        />
        <FormField
          label="Maximum capacity"
          name="capacity_max"
          type="number"
          min="0"
          value={formData.capacity_max}
          onChange={handleChange}
          error={errors.capacity_max}
          placeholder="0"
          required
          disabled={readOnly}
          icon={
            <path
              d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
            />
          }
        />
      </div>
      <FormField
        label="Full address *"
        name="full_address"
        type="textarea"
        value={formData.full_address}
        onChange={handleChange}
        error={errors.full_address}
        placeholder="Enter full address"
        required
        rows={2}
        disabled={readOnly}
        icon={
          <path
            d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
          />
        }
      />
      <div className="step1-form-row">
        <FormField
          label="City"
          name="city"
          type="select"
          value={formData.city}
          onChange={handleChange}
          error={errors.city}
          placeholder="Select city"
          required
          options={cityOptions}
          disabled={readOnly}
          icon={
            <path
              d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
            />
          }
        />
        <FormField
          label="State"
          name="state"
          value={formData.state}
          onChange={handleChange}
          error={errors.state}
          placeholder="Enter state"
          required
          disabled={readOnly}
          icon={
            <path
              d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
            />
          }
        />
      </div>
      <FormField
        label="Pincode"
        name="pincode"
        value={formData.pincode}
        onChange={handleChange}
        error={errors.pincode}
        placeholder="6-digit pincode"
        required
        disabled={readOnly}
        icon={
          <path
            d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
          />
        }
      />
    </div>
  );
}

export default Step2VenueDetails;
